import React from 'react';
import useAuth from "../hooks/useAuth.js";
import Navbar from './Navbar.js';
import Hero from './Hero.js';
import Features from './Features.js';
import Features2 from './Features2.js';
import GroupFundingSection from './GroupFundingSection.js';
import Testimonials from './Testimonials.js';
import CallToAction from './CallToAction.js';
import Footer from './Footer.js';
import FeaturesSection from './NewFeatures.js';
import FAQ from './Faq.js';

function Home() {
  const { isAuthenticated } = useAuth();

  return (
    <section id='homepage' >
      <Navbar isAuthenticated={isAuthenticated} />
      <Hero />
      <GroupFundingSection />
      <FeaturesSection />
      <div className="block lg:hidden">
        <Features2 />
      </div>
      <div className="hidden lg:block">
        <Features />
      </div>
      <Testimonials />
      <FAQ />
      <CallToAction />
      <Footer />
    </section>
  );
}

export default Home;